// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/broadcast-messages-view/app/css/app.css
// module id = 829
// module chunks = 0